// utils/truncate.ts
export const truncate = (s: string | null | undefined, n = 15) =>
  (s ?? "").length > n ? (s as string).slice(0, n) + "..." : s ?? "";

export function getYouTubeId(rawUrl: string): string | null {
  try {
    const url = new URL(rawUrl.trim());
    if (url.hostname.includes("youtu.be")) {
      return url.pathname.replace("/", "") || null;
    }
    if (url.hostname.includes("youtube.com")) {
      const v = url.searchParams.get("v");
      if (v) return v;
      const parts = url.pathname.split("/");
      const i = parts.findIndex((p) => p === "embed");
      if (i >= 0 && parts[i + 1]) return parts[i + 1];
    }
    const m = rawUrl.match(/(?:v=|\/embed\/|youtu\.be\/)([A-Za-z0-9_-]{6,})/i);
    return m?.[1] ?? null;
  } catch {
    const m = rawUrl.match(/(?:v=|\/embed\/|youtu\.be\/)([A-Za-z0-9_-]{6,})/i);
    return m?.[1] ?? null;
  }
}

/**
 * Monta a URL de embed com autoplay/mute por padrão.
 * `startSeconds` permite começar em um tempo específico (segundos).
 */
export function buildYouTubeEmbedUrl(
  videoId: string,
  opts?: { autoplay?: boolean; mute?: boolean; startSeconds?: number }
) {
  const autoplay = opts?.autoplay ?? true;
  const mute = opts?.mute ?? true;
  const start = opts?.startSeconds ?? 0;

  const params = new URLSearchParams({
    autoplay: autoplay ? "1" : "0",
    mute: mute ? "1" : "0",
    rel: "0",
    modestbranding: "1",
    playsinline: "1",
    // controla teclas e UI:
    // controls=1 (padrão), você pode alterar se quiser:
    controls: "1"
  });

  if (start > 0) params.set("start", String(start));

  return `https://www.youtube.com/embed/${encodeURIComponent(
    videoId
  )}?${params.toString()}`;
}
